import { getDate, getMonth, getYear } from 'date-fns';
import { format as dateFnsTzFormat, OptionsWithTZ, utcToZonedTime } from 'date-fns-tz';
import { addUnitsOfTime, startOf, TimeUnit } from './DateFns';

export function toTimezoneAndFormat(date: Date, format: string, timeZone: string, options?: OptionsWithTZ) {
    const dateInTimezone = utcToZonedTime(date, timeZone);
    const formatOptions = {
        timeZone,
        ...options,
    };

    return dateFnsTzFormat(dateInTimezone, format, formatOptions);
}

export function* dateRange(start: Date, end: Date, unit: TimeUnit = 'day'): Iterator<Date> {
    for (
        let day = startOf(start, unit);
        getYear(day) < getYear(end) || getMonth(day) < getMonth(end) || getDate(day) < getDate(end);
        day = addUnitsOfTime(day, 1, unit)
    ) {
        yield day;
    }
}

export function* mergeDateData<T>(
    start: Date,
    end: Date,
    dates: Date[],
    data: T[],
    emptyValue: T | null,
    unit: TimeUnit = 'day'
): Iterator<T | null> {
    const allDates = dateRange(start, end, unit);

    console.assert(dates.length == data.length);

    for (let it = allDates.next(); !it.done; it = allDates.next()) {
        const idx = dates.findIndex(
            d => getYear(d) == getYear(it.value) && getMonth(d) == getMonth(it.value) && getDate(d) == getDate(it.value)
        );

        if (idx >= 0) yield data[idx];
        else yield emptyValue;
    }
}
